import src from "IMAGE";
export default { src, width: 2280, height: 340, blurWidth: 0, blurHeight: 0};
